export enum CollapseState {
	ExpandAll = 'ExpandAll',
	CollapseAll = 'CollapseAll',
	Mixed = 'Mixed',
	RevealAllHTML = 'RevealAllHTML',
	ExpandAllQuestions = 'ExpandAllQuestions'
}
